/**
 * The generated OpenAPI paths already include `/api/v1`.
 *
 * In same-origin deployments the API client base URL must therefore be empty;
 * using `/api` would produce `/api/api/v1/...` and bypass the real routes.
 */
export function resolveApiBaseUrl(raw: string | undefined): string {
  const value = raw?.trim();
  if (!value) return '';
  return value.replace(/\/api\/?$/u, '');
}
